import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'Search',
})
export class SearchPipe implements PipeTransform {
  constructor() {}

  transform(items: Array<any>, keyword: string, activeType: string): Array<any> {
    // 키워드가 있을 때
    if (keyword && items && activeType) {
      if (activeType == '회원 상태 전체') {
        return items.filter(ele => {
          return ele.name.indexOf(keyword) > -1 || ele.email.indexOf(keyword) > -1 || ele.nickName.indexOf(keyword) > -1;
        });
      }
      if (activeType != '회원 상태 전체') {
        switch (activeType) {
          case '일반': {
            const uniqItems = items.filter(member => !member.suspendSwitch && !member.exitSwitch);
            return uniqItems.filter(ele => {
              return ele.name.indexOf(keyword) > -1 || ele.email.indexOf(keyword) > -1 || ele.nickName.indexOf(keyword) > -1;
            });
          }
          case '정지': {
            const uniqItems = items.filter(member => member.suspendSwitch);
            return uniqItems.filter(ele => {
              return ele.name.indexOf(keyword) > -1 || ele.email.indexOf(keyword) > -1 || ele.nickName.indexOf(keyword) > -1;
            });
          }
          case '탈퇴': {
            const uniqItems = items.filter(member => member.exitSwitch);
            return uniqItems.filter(ele => {
              return ele.name.indexOf(keyword) > -1 || ele.email.indexOf(keyword) > -1 || ele.nickName.indexOf(keyword) > -1;
            });
          }
        }
      }
    }
    // 키워드가 없을 때
    if (!keyword && items && activeType) {
      if (activeType == '회원 상태 전체') {
        return items;
      }
      if (activeType != '회원 상태 전체') {
        switch (activeType) {
          case '일반': {
            return items.filter(member => !member.suspendSwitch && !member.exitSwitch);
          }
          case '정지': {
            return items.filter(member => member.suspendSwitch);
          }
          case '탈퇴': {
            return items.filter(member => member.exitSwitch);
          }
        }
      }
    }
  }
}
